import ProfesionService from "@/services/ProfesionService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const profesion = {
    namespace:true,
    state: {profesions:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListProfesion({commit},pageNumber){
            return await ProfesionService.getlist(pageNumber).then(
                response=>{    
                    commit('setProfesions',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListProfesion({commit},search){          
            return await ProfesionService.getSearch(search).then (
                response =>{                    
                    commit('setProfesions',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setProfesions(state,data){
        state.profesions = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.profesions.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};